import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Gauge, Users, MessageSquare, Wrench, Stethoscope, GraduationCap, Trophy, LogOut, Car,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Overview", icon: Gauge, tid: "nav-overview" },
  { to: "/mechanics", label: "Mechanics", icon: Users, tid: "nav-mechanics" },
  { to: "/vehicles", label: "Vehicles", icon: Car, tid: "nav-vehicles" },
  { to: "/simulator", label: "WhatsApp Simulator", icon: MessageSquare, tid: "nav-simulator" },
  { to: "/diagnostics", label: "Diagnostics Log", icon: Stethoscope, tid: "nav-diagnostics" },
  { to: "/repairs", label: "Repair History", icon: Wrench, tid: "nav-repairs" },
  { to: "/lessons", label: "Daily Lessons", icon: GraduationCap, tid: "nav-lessons" },
  { to: "/rewards", label: "Rewards", icon: Trophy, tid: "nav-rewards" },
];

export default function AppShell({ children }) {
  const loc = useLocation();
  const nav = useNavigate();
  const email = localStorage.getItem("gs_email") || "admin";

  const logout = () => {
    localStorage.removeItem("gs_token");
    localStorage.removeItem("gs_email");
    nav("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#090A0B] text-zinc-100">
      {/* Sidebar */}
      <aside className="w-60 border-r border-zinc-900 flex flex-col">
        <div className="p-5 border-b border-zinc-900">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-amber-500 flex items-center justify-center">
              <Wrench className="w-4 h-4 text-black" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-display font-black text-base leading-none">GarajSync</div>
              <div className="text-[10px] text-zinc-500 font-mono-data mt-1">ops.console</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-3" data-testid="sidebar-nav">
          <div className="overline px-4 mb-2">Modules</div>
          {NAV.map(({ to, label, icon: Icon, tid }) => {
            const active = to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to);
            return (
              <Link key={to} to={to} className={`nav-item ${active ? "active" : ""}`} data-testid={tid}>
                <Icon className="w-4 h-4" strokeWidth={2} />
                <span>{label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="border-t border-zinc-900 p-3">
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0">
              <div className="text-xs text-zinc-300 truncate">{email}</div>
              <div className="text-[10px] text-zinc-600 font-mono-data">admin</div>
            </div>
            <button
              data-testid="logout-btn"
              onClick={logout}
              className="text-zinc-500 hover:text-amber-500 p-1.5 hover:bg-zinc-900"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-x-hidden">{children}</main>
    </div>
  );
}
